(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contadorpipefy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function targetFor(root) {
      var mode = root.dataset.bcMode;
      var now = new Date();
      if (mode === 'fixed') {
        var raw = (root.dataset.bcDate || '').trim();
        if (!raw) return null;
        var d = new Date(raw.replace(/-/g, '/').replace('T', ' '));
        if (isNaN(d.getTime())) {
          d = new Date(raw);
          if (isNaN(d.getTime())) return null;
        }
        return d;
      }
      var hour = parseInt(root.dataset.bcHour || '0', 10);
      var min = parseInt(root.dataset.bcMinute || '0', 10);
      if (mode === 'weekly') {
        var wd = parseInt(root.dataset.bcWeekday || '1', 10);
        var t = new Date(now);
        t.setHours(hour, min, 0, 0);
        var diff = (wd - t.getDay() + 7) % 7;
        t.setDate(t.getDate() + diff);
        if (t <= now) t.setDate(t.getDate() + 7);
        return t;
      }
      var td = new Date(now);
      td.setHours(hour, min, 0, 0);
      if (td <= now) td.setDate(td.getDate() + 1);
      return td;
    }

    function tiles(str, id) {
      var out = '';
      for (var i = 0; i < str.length; i++) {
        out += '<span class="bc-digito-' + id + '">' + str[i] + '</span>';
      }
      return out;
    }

    function render(root) {
      var timer = root.querySelector('[data-bc-timer]');
      if (!timer) return;
      var id = root.dataset.bcId;
      var now = new Date();
      var secsLeft = root._bcTarget ? Math.floor((root._bcTarget - now) / 1000) : 0;

      if (secsLeft <= 0) {
        if (root.dataset.bcMode !== 'fixed') {
          root._bcTarget = targetFor(root);
          secsLeft = root._bcTarget ? Math.max(0, Math.floor((root._bcTarget - now) / 1000)) : 0;
        } else {
          secsLeft = 0;
        }
      }

      var days = Math.floor(secsLeft / 86400);
      var hours = Math.floor((secsLeft % 86400) / 3600);
      var mins = Math.floor((secsLeft % 3600) / 60);
      var secs = secsLeft % 60;

      var units = [];
      if (root.dataset.bcDays === '1') units.push([String(days), root.dataset.bcLblDays]);
      units.push([pad(hours), root.dataset.bcLblHours]);
      units.push([pad(mins), root.dataset.bcLblMinutes]);
      units.push([pad(secs), root.dataset.bcLblSeconds]);

      var isTiles = root.dataset.bcStyle === 'tiles';
      var html = '';
      for (var i = 0; i < units.length; i++) {
        if (i > 0 && isTiles) html += '<span class="bc-sep-' + id + '">:</span>';
        var numHtml = isTiles ? tiles(units[i][0], id) : units[i][0];
        html += '<span class="bc-unidad-' + id + '">' +
          '<span class="bc-numero-' + id + '">' + numHtml + '</span>' +
          '<span class="bc-etiqueta-' + id + '">' + (units[i][1] || '') + '</span>' +
          '</span>';
      }
      timer.innerHTML = html;
    }

    function copyCode(btn) {
      var code = btn.getAttribute('data-bc-copy') || '';
      var lbl = btn.querySelector('[data-bc-codetext]');
      var done = function () {
        if (!lbl) return;
        if (btn._bcBusy) return;
        btn._bcBusy = true;
        var orig = lbl.textContent;
        lbl.textContent = btn.getAttribute('data-bc-copied') || 'OK';
        setTimeout(function () { lbl.textContent = orig; btn._bcBusy = false; }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        done();
      }
    }

    function initRoot(root) {
      if (root.dataset.bcInit) return;
      root.dataset.bcInit = '1';

      try {
        if (sessionStorage.getItem('bc-closed-' + root.dataset.bcId) === '1') {
          root.style.display = 'none';
          return;
        }
      } catch (e) {}

      if (root.dataset.bcPos === 'fixed') {
        var spacer = document.createElement('div');
        spacer.style.height = root.offsetHeight + 'px';
        root.parentNode.insertBefore(spacer, root);
        root._bcSpacer = spacer;
        window.addEventListener('resize', function () { spacer.style.height = root.offsetHeight + 'px'; });
      }

      root.addEventListener('click', function (e) {
        var copyBtn = e.target.closest('[data-bc-copy]');
        if (copyBtn) { copyCode(copyBtn); return; }
        var closeBtn = e.target.closest('[data-bc-close]');
        if (closeBtn) {
          root.style.display = 'none';
          if (root._bcSpacer) root._bcSpacer.style.display = 'none';
          try { sessionStorage.setItem('bc-closed-' + root.dataset.bcId, '1'); } catch (er) {}
        }
      });

      root._bcTarget = targetFor(root);
      render(root);
      root._bcInterval = setInterval(function () { render(root); }, 1000);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bc-root]').forEach(initRoot);
    }

    if (document.readyState !== 'loading') initAll();
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custo-beneficios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pip-tabs__tab'));
    var paneles = Array.prototype.slice.call(root.querySelectorAll('.pip-tabs__panel'));
    if (!tabs.length) return;

    function activar(indice) {
      tabs.forEach(function (tab) {
        var activo = tab.getAttribute('data-indice') === String(indice);
        tab.classList.toggle('pip-tabs__tab--activo', activo);
        tab.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
      paneles.forEach(function (panel) {
        var activo = panel.getAttribute('data-indice') === String(indice);
        panel.classList.toggle('pip-tabs__panel--activo', activo);
        panel.hidden = !activo;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activar(tab.getAttribute('data-indice'));
      });
      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(tab);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var siguiente = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
          if (siguiente < 0) siguiente = tabs.length - 1;
          if (siguiente >= tabs.length) siguiente = 0;
          tabs[siguiente].focus();
          activar(tabs[siguiente].getAttribute('data-indice'));
        }
      });
    });

    root.addEventListener('shopify:block:select', function (e) {
      var idx = e.target.getAttribute('data-indice');
      if (idx !== null) activar(idx);
    });
  }

  function iniciar() {
    document.querySelectorAll('.pip-tabs').forEach(iniciarTabs);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-tabs');
    if (el) iniciarTabs(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFaq(root) {
    var cerrarOtras = root.getAttribute('data-cerrar-otras') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('.pip-faq__item'));

    items.forEach(function (item) {
      var btn = item.querySelector('.pip-faq__pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('pip-faq__item--abierto');
        if (cerrarOtras) {
          items.forEach(function (otro) {
            otro.classList.remove('pip-faq__item--abierto');
            var b = otro.querySelector('.pip-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (abierto) {
          item.classList.remove('pip-faq__item--abierto');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('pip-faq__item--abierto');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var toggle = root.querySelector('.pip-faq__toggle');
    if (toggle) {
      var extras = Array.prototype.slice.call(root.querySelectorAll('[data-extra="true"]'));
      var textoMas = toggle.getAttribute('data-mas');
      var textoMenos = toggle.getAttribute('data-menos');
      toggle.addEventListener('click', function () {
        var expandido = toggle.getAttribute('aria-expanded') === 'true';
        if (expandido) {
          extras.forEach(function (ex) {
            ex.classList.remove('pip-faq__item--abierto');
            var b = ex.querySelector('.pip-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
            ex.hidden = true;
          });
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = textoMas;
        } else {
          extras.forEach(function (ex) { ex.hidden = false; });
          toggle.setAttribute('aria-expanded', 'true');
          toggle.textContent = textoMenos;
        }
      });
    }

    var video = root.querySelector('.pip-faq__video');
    var mediaBtn = root.querySelector('.pip-faq__media-btn');
    if (video && mediaBtn) {
      mediaBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          mediaBtn.setAttribute('data-estado', 'reproduciendo');
        } else {
          video.pause();
          mediaBtn.setAttribute('data-estado', 'pausado');
        }
      });
      video.addEventListener('play', function () { mediaBtn.setAttribute('data-estado', 'reproduciendo'); });
      video.addEventListener('pause', function () { mediaBtn.setAttribute('data-estado', 'pausado'); });
    }
  }

  function iniciar() {
    document.querySelectorAll('.pip-faq').forEach(iniciarFaq);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-faq');
    if (el) iniciarFaq(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["findpack-pip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarPack(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__tab'));
    var paneles = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__panel'));
    var medios = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__media'));
    var botones = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__boton'));
    if (!tabs.length) return;

    var total = tabs.length;
    var actual = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';

    function porIndice(lista, indice) {
      lista.forEach(function (el) {
        var activo = el.getAttribute('data-indice') === String(indice);
        el.hidden = !activo;
        el.classList.toggle('pip-pack__panel--activo', activo && el.classList.contains('pip-pack__panel'));
        el.classList.toggle('pip-pack__media--activo', activo && el.classList.contains('pip-pack__media'));
        el.classList.toggle('pip-pack__boton--activo', activo && el.classList.contains('pip-pack__boton'));
      });
    }

    function activar(indice) {
      actual = ((indice % total) + total) % total;
      tabs.forEach(function (tab) {
        var activo = tab.getAttribute('data-indice') === String(actual);
        tab.classList.remove('pip-pack__tab--activo');
        tab.setAttribute('aria-selected', activo ? 'true' : 'false');
        if (activo) {
          void tab.offsetWidth;
          tab.classList.add('pip-pack__tab--activo');
        }
      });
      porIndice(paneles, actual);
      porIndice(medios, actual);
      porIndice(botones, actual);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activar(parseInt(tab.getAttribute('data-indice'), 10));
      });
    });

    if (autoplay && total > 1) {
      tabs.forEach(function (tab) {
        var ring = tab.querySelector('.pip-pack__ring circle');
        if (ring) {
          ring.addEventListener('animationend', function () {
            if (tab.classList.contains('pip-pack__tab--activo')) {
              activar(actual + 1);
            }
          });
        }
      });

      if (root.classList.contains('pip-pack--pausable')) {
        root.addEventListener('mouseenter', function () { root.classList.add('pip-pack--pausado'); });
        root.addEventListener('mouseleave', function () { root.classList.remove('pip-pack--pausado'); });
      }
    }

    root.addEventListener('shopify:block:select', function (e) {
      var idx = e.target.getAttribute('data-indice');
      if (idx !== null) activar(parseInt(idx, 10));
    });

    activar(0);
  }

  function iniciar() {
    document.querySelectorAll('.pip-pack').forEach(iniciarPack);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-pack');
    if (el) iniciarPack(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerpipefy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.phInit) return;
      root.dataset.phInit = '1';

      var bar = root.querySelector('.ph-bar');
      var over = root.dataset.phOver === '1';

      if (over) {
        var onScroll = function () {
          if (window.pageYOffset > 60) root.classList.add('ph-solid');
          else root.classList.remove('ph-solid');
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      var nav = root.querySelector('[data-ph-nav]');
      var slider = root.querySelector('[data-ph-slider]');
      if (nav && slider) {
        var items = nav.querySelectorAll('[data-ph-link]');
        items.forEach(function (link) {
          link.addEventListener('mouseenter', function () {
            slider.style.left = link.offsetLeft + 'px';
            slider.style.width = link.offsetWidth + 'px';
            slider.style.height = link.offsetHeight + 'px';
            slider.style.opacity = '1';
          });
        });
        nav.addEventListener('mouseleave', function () { slider.style.opacity = '0'; });
      }

      var burger = root.querySelector('[data-ph-burger]');
      var closeBtn = root.querySelector('[data-ph-close]');
      var overlay = root.querySelector('[data-ph-overlay]');
      var openDrawer = function () { root.classList.add('ph-open'); document.body.style.overflow = 'hidden'; };
      var closeDrawer = function () { root.classList.remove('ph-open'); document.body.style.overflow = ''; };
      if (burger) burger.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      root.querySelectorAll('[data-ph-dtoggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-ph-dsub]');
          if (item) item.classList.toggle('is-open');
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ph-root]').forEach(initRoot);
    }

    if (document.readyState !== 'loading') initAll();
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
